// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mh-treeMenu[data-v-1f51586b] {\r\n  width: 100%;\r\n  padding: 0.5rem;\r\n  box-sizing: border-box;\n}\r\n", ""]);
// Exports
module.exports = exports;
